<template>
<div class="chapter">
<div class="inner_page">
<a id="p1"></a>
<div class="copyright">
<p class="left ">Copyright © 2021 by Amy Gentry</p>
<p class="left spaceabove1">All rights reserved</p>
<p class="left spaceabove1">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<p class="left spaceabove1"><a href="https://hmhbooks.com/" target="_blank">hmhbooks.com</a></p>
<p class="left spaceabove1"><em>Library of Congress Cataloging-in-Publication Data</em></p>
<p class="left ">Names: Gentry, Amy, author.</p>
<p class="left ">Title: Bad habits / Amy Gentry.</p>
<p class="left ">Description: Boston : Mariner Books, Houghton Mifflin Harcourt, 2021.</p>
<p class="left ">Identifiers: <span class="smallcaps">LCCN</span> 2020034157 (print) | <span class="smallcaps">LCCN</span> 2020034158 (ebook) | <span class="smallcaps">ISBN</span> 9780358408574 (trade paperback) | <span class="smallcaps">ISBN</span> 9780358126546 (hardcover) | <span class="smallcaps">ISBN</span> 9780358439974 | <span class="smallcaps">ISBN</span> 9780358440871 | <span class="smallcaps">ISBN</span> 9780358125051 (ebook)</p>
<p class="left ">Subjects: <span class="smallcaps">LCSH</span>: Psychological fiction. | <span class="smallcaps">GSAFD</span>: Suspense fiction.</p>
<p class="left ">Classification: <span class="smallcaps">LCC PS</span>3607.<span class="smallcaps">E</span>567 <span class="smallcaps">B</span>33 2021 (print) | <span class="smallcaps">LCC PS</span>3607.<span class="smallcaps">E</span>567 (ebook) | <span class="smallcaps">DDC</span> 813/.6—dc23</p>
<p class="left ">LC record available at https://lccn.loc.gov/2020034157</p>
<p class="left ">LC ebook record available at https://lccn.loc.gov/2020034158</p>
<p class="left spaceabove1">Cover design by Christopher Moisan</p>
<p class="left ">Cover photographs: Shutterstock and © Ildiko Neer/Trevillion Images</p>
<p class="left ">Author photograph © Matt Valentine</p>
<p class="left spaceabove1">v1.0121</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?ffb7e364